import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './oh-w4.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

// Ohio IT-4 (StateProvinceID 37, requestTypeId 2). APEX-868.
// Employee-only certificate (no employer section). Section III waiver checkboxes use PDF on-value "On".
const OH_STATE_ID = 37;

export const OhW4Component = {
    templateUrl,
    controller: OhW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
};

function OhW4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.formatSsn = formatSsn;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.syncFormToProfile = syncFormToProfile;
    vm.stateWitholdingTypeID = 5;
    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.disableEmprFields = false;
    vm.isSaved = false;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.fillLockedInfo = fillLockedInfo;
    vm.onEditClicked = onEditClicked;
    vm.state = { view: 'W4' };

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.FullName != null && !vm.ownerView) {
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
        } else if (vm.userInputs != null && vm.userInputs.FullName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            if (vm.application.ProvinceW4 === "Pending") {
                fillLockedInfo();
            }
        } else {
            prefillFromProfile.call(this);
        }

        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
        vm.editable = resolveEditable();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }
        return !vm.application.HasSW4Form || formStatus === 'Pending' || formStatus === 'ReviewRequired';
    }


    // Locked, profile-sourced fields (name, ssn, address) shown read-only.
    function fillLockedFromProfile() {
        vm.fullName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        const a = vm.profile.HomeAddress;
        const st = vm.stateProvinces.find(x => x.StateProvinceID === a?.StateProvinceID);
        vm.address = [a.StreetLine1, a.StreetLine2, a.AptNum, a.City, st ? st.Abbr : '', a.PostalCode].filter(Boolean).join(', ');
    }

    function prefillFromProfile() {
        fillLockedFromProfile();
    }

    function fillLockedInfo() {
        fillLockedFromProfile();
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            fillLockedFromProfile();
        }
    }

    // Retrieved values are strings; numeric inputs must be coerced or Angular throws on load.
    function toNumOrNull(v) {
        return v != null && v !== '' ? Number(v) : null;
    }

    function fillEmployee(data) {
        fillLockedFromProfile();
        vm.schoolDistrictResidence = data.SchoolDistrictOfResidence;
        vm.schoolDistrictNumber = data.SchoolDistrictNumber;
        vm.dependentWithholding = toNumOrNull(data.DependentWithholding);
        vm.separateWithholding = toNumOrNull(data.SeparateWithholding);
        vm.numberOfDependents = toNumOrNull(data.NumberOfDependents);
        vm.totalExemptions = toNumOrNull(data.TotalWithholdingExemptions);
        vm.addlAmount = toNumOrNull(data.AdditionalStateWithholding);
        vm.fullYearResident = data.FullYearResident === 'On';
        vm.residentMilitary = data.ResidentMilitary === 'On';
        vm.nonresidentMilitary = data.NonresidentMilitary === 'On';
        vm.nonresidentCivilianSpouse = data.NonresidentCivilianSpouse === 'On';
        vm.exempt = data.Exempt === 'On';
        if (data.Signature) {
            vm.signimage = data.Signature; vm.isSigned = true;
        }
        vm.prefilled = true;
        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();
    }

    // FormRequest is all-string; stringify every value. Section III checkboxes send PDF on/off literals "On"/"Off".
    function buildFormData(includeSignature) {
        const s = (v) => (v == null ? '' : String(v));
        const formData = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: s(vm.fullName),
            EmployeeSocialSecurityNumber: s(vm.employeeSsn),
            EmployeeAddress: s(vm.address),
            SchoolDistrictOfResidence: s(vm.schoolDistrictResidence),
            SchoolDistrictNumber: s(vm.schoolDistrictNumber),
            DependentWithholding: s(vm.dependentWithholding != null ? vm.dependentWithholding : ''),
            SeparateWithholding: s(vm.separateWithholding != null ? vm.separateWithholding : ''),
            NumberOfDependents: s(vm.numberOfDependents != null ? vm.numberOfDependents : ''),
            TotalWithholdingExemptions: s(vm.totalExemptions != null ? vm.totalExemptions : ''),
            AdditionalStateWithholding: s(vm.addlAmount != null ? vm.addlAmount : ''),
            FullYearResident: vm.fullYearResident ? 'On' : 'Off',
            ResidentMilitary: vm.residentMilitary ? 'On' : 'Off',
            NonresidentMilitary: vm.nonresidentMilitary ? 'On' : 'Off',
            NonresidentCivilianSpouse: vm.nonresidentCivilianSpouse ? 'On' : 'Off',
            Exempt: vm.exempt ? 'On' : 'Off',
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: includeSignature ? vm.signimage : undefined
        };
        return formData;
    }

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, 'Request review failed'));
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', String(OH_STATE_ID), pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    // New-Hires-File columns: AA <- Step 4 (total exemptions), AE <- Step 5 (additional withholding, type 5 'S'),
    // AF <- any Section III box. Z/AB/AC/AD not on the OH IT-4 (left untouched).
    function syncFormToProfile() {
        vm.employeeBankInfo.RegularWithholdingAllowances = vm.totalExemptions;
        vm.employeeBankInfo.EmployeeWithholdingInfos = vm.employeeBankInfo.EmployeeWithholdingInfos.filter(function (x) {
            return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
        });
        if (vm.addlAmount != null && vm.addlAmount !== '') {
            vm.employeeBankInfo.EmployeeWithholdingInfos.push({
                EmployeeId: vm.employee.EmployeeID,
                WithholdingTypeID: vm.stateWitholdingTypeID,
                AdditionalWithholdingAmount: vm.addlAmount
            });
        }
        vm.employeeBankInfo.StateTaxExempt = !!(vm.fullYearResident || vm.residentMilitary || vm.nonresidentMilitary || vm.nonresidentCivilianSpouse || vm.exempt);
    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, OH_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: { title: () => "Ohio IT-4", previewUrl: () => vm.previewUrl }
                }).result;
            }).then(function (data) {
                if (!data || !data.dataUrl) {
                    utilityService.hideLoading(); return;
                }
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                return onSubmit();
            }).catch((err) => {
                console.log(err); utilityService.hideLoading();
            });
    }

    function onSave() {
        utilityService.showLoading();
        const formData = buildFormData(false);
        return onboardingDocumentService.save(vm.employee.UserName, formData, OH_STATE_ID).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        }).catch(function (err) {
            console.log(err); return utilityService.hideLoading();
        });
    }

    function onApprove() {
        const approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            vm.onShowI9();
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, "Approve failed"));
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        const updatePromises = [];
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading(); alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading(); alert("Signature is required"); return;
            }
            const formData = buildFormData(true);
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(() => employeeService.updateEmployeeOnboardingBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
            }
            updatePromises.push(() => onboardingDocumentService.submit(vm.employee.UserName, formData, OH_STATE_ID));
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }
        const trans = updatePromises.reduce((chain, promise) => {
            return chain.then(() => (typeof promise === 'function' ? promise() : promise));
        }, $q.resolve()).then((res) => {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(utilityService.alertOnError(trans, "Save failed"));
    }

    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields."); return;
        }
        utilityService.showLoading();
        const formData = buildFormData(true);
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, OH_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "Ohio IT-4",
                        previewUrl: () => vm.previewUrl,
                        allowApprove: () => canApproveForm(vm.application, '2'),
                        allowSign: () => false,
                        showSignaturePopup: () => vm.showSignaturePopup
                    }
                }).result;
            }).then(function (data) {
                if (data === 'terminate' && vm.showSignaturePopup) {
                    return vm.close({ $value: 'ok' });
                }
                if (data && data.success) {
                    vm.employerSignimage = data.dataUrl; vm.isSigned = true; return onSubmit();
                }
            }).catch((err) => {
                console.log(err); utilityService.hideLoading();
            });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "application-status"
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID).then(function (translations) {
            return translations;
        });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                return locales.filter(function (locale) {
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function formatSsn(ssn) {
        if (!ssn) return "";
        var digits = ("" + ssn).replace(/[^0-9]/g, "");
        if (digits.length !== 9) return ssn;
        var mask = vm.employeeBankInfo
            && vm.employeeBankInfo.Translations
            && vm.employeeBankInfo.Translations.SSNMask;
        if (mask === "000-000-000") {
            return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6, 9);
        }
        return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5, 9);
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
}

export const OHW4Modal = {
    component: "apexOHW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
